module.exports = __webpack_public_path__ + "static/media/YM72_2.e1577c08.jpg";